import PageArticleDetail from '~/themes/base/components/content/PageArticleDetail'

export default {
  extends: PageArticleDetail,

  head() {
    const baseHead = this.getSeoHead ? this.getSeoHead() : {}

    const articleUrl = this.makeAbsoluteUrl(this.$route.path)
    const image =
      (this.article.image && this.article.image.length
        ? this.imageUrl({ src: this.article.image[0].path, width: 2000 })
        : this.logoUrl) || null

    const author = this.articleAuthors && this.articleAuthors.length ? this.articleAuthors[0] : null

    const authorName = author && author.title ? author.title : this.$t('globals.website')

    const authorUrl =
      author && author.page_meta && author.author_has_page
        ? this.makeAbsoluteUrl(this.localePath({ name: 'author-slug', params: { slug: author.page_meta.slug } }))
        : null

    const category = this.articleCategories && this.articleCategories.length ? this.articleCategories[0] : null

    const articleSection = category && category.title ? category.title : null

    const siteName = this.getSeoShortTitle ? this.getSeoShortTitle() : this.$t('globals.website')

    // --- NewsArticle JSON-LD ---
    const articleJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: this.article.title,
      description: this.article.perex || '',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': articleUrl,
      },
      datePublished: this.article.date_published || undefined,
      dateModified: this.article.date_published || undefined,
      image: image ? [image] : undefined,
      inLanguage: this.$i18n.locale || 'cs',
      author: {
        '@type': 'Person',
        name: authorName,
        ...(authorUrl ? { url: authorUrl } : {}),
      },
      publisher: {
        '@type': 'Organization',
        name: siteName,
        logo: {
          '@type': 'ImageObject',
          url: this.logoUrl,
        },
      },
      ...(articleSection ? { articleSection } : {}),
    }

    // --- BreadcrumbList JSON-LD ---
    const breadcrumbItems = this.breadcrumbs.map((bc, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: bc.title,
      item: this.makeAbsoluteUrl(typeof bc.path === 'string' ? bc.path : this.localePath(bc.path)),
    }))

    const breadcrumbJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems,
    }

    const extraScripts = [
      {
        hid: 'ld-json-article',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(articleJsonLd),
      },
      {
        hid: 'ld-json-breadcrumb',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(breadcrumbJsonLd),
      },
    ]

    const existingScripts = baseHead.script || []
    const existingSanitizers = baseHead.__dangerouslyDisableSanitizers || []
    const sanitizers = existingSanitizers.includes('script')
      ? existingSanitizers
      : [...existingSanitizers, 'script']

    return {
      ...baseHead,
      script: [...existingScripts, ...extraScripts],
      __dangerouslyDisableSanitizers: sanitizers,
    }
  },
  async mounted() {
    await this.$nextTick()
    // Opens all article links in a new tab / window
    const anchors = document.querySelectorAll('.ContentBuilder__text a')
    anchors.forEach(a => {
      a.setAttribute('target', '_blank')
    })

    // Legacy code for images transferred from the old domain
    const images = document.querySelectorAll('.ContentBuilder__text img')
    images.forEach(image => {
      let src = image.getAttribute('src')
      src = src.replace(
        'http://www.ventilator-shop.com/storage/filemanager/source/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace(
        'http://www.ventilator-profis.de/storage/filemanager/source/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/de/',
      )
      src = src.replace(
        'http://www.ventilatory-shop.cz/storage/filemanager/source/articles/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace(
        'https://www.ventilatory-shop.cz/storage/filemanager/source/articles/',
        'https://cdn.store.cvb-new.prod.inspishop.cz/image/original/content/articles/',
      )
      src = src.replace('https://cdn.ventilatory-shop.cz/image/', 'https://cdn.store.cvb-new.prod.inspishop.cz/image/')
      src = src.replace('https://cdn.ventilator-profis.de/image/', 'https://cdn.store.cvb-new.prod.inspishop.cz/image/')
      src = src.replace('../image', 'https://cdn.store.cvb-new.prod.inspishop.cz/image')
      image.setAttribute('src', src)
    })
  },
}
